/**
 * Funcion para generar el deviceIDdelPortal
 * @param {string} merchantID
 * @param {live} environment
 * @returns {bolean}
 */

 export function cybs_dfprofiler(merchantID, environment){
    let org_id
    let str
    if (environment.toLowerCase() === 'live') {
        org_id = 'k8vif92e'
    } else {
        org_id = '1snn5n9w'
    }

    const sessionID = new Date().getTime()
    let paragraphTM = document.createElement("p")

    str = "background:url(https://h.online-metrix.net/fp/clear.png?org_id=" + org_id + "&session_id=" + merchantID + sessionID + "&m=1)"
    paragraphTM.styleSheets = str
    paragraphTM.height = "0"
    paragraphTM.width = "0"
    paragraphTM.hidden = "true"
    document.body.appendChild(paragraphTM)

    let img = document.createElement("img")
    str = "https://h.online-metrix.net/fp/clear.png?org_id=" + org_id + "&session_id=" + merchantID + sessionID + "&m=2"
    img.src = str
    document.body.appendChild(img)

    let tmscript = document.createElement("script")
    tmscript.src = "https://h.online-metrix.net/fp/check.js?org_id=" + org_id + "&session_id=" + merchantID + sessionID
    tmscript.type = "text/javascript"
    document.body.appendChild(tmscript)

    let objectTM = document.createElement("object")
    objectTM.data = "https://h.online-metrix.net/fp/fp.swf?org_id=" + org_id + "&session_id=" + merchantID + sessionID
    objectTM.width = "1"
    objectTM.height = "1"
    objectTM.id = "thm_fp"

    let param = document.createElement("param")
    param.name = "movie"
    param.value = "https://h.online-metrix.net/fp/fp.swf?org_id=" + org_id + "&session_id=" + merchantID + sessionID
    objectTM.appendChild(param)
    document.body.appendChild(objectTM)
    return sessionID
 }